import { Divider, ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { isEmptyArray } from '@vy/utils';
import React from 'react';
import { VyDialog } from '../../../../components/new-design/feedback/VyDialog';
import { useDeleteMeasurements } from '../../../../hooks/requests/use-delete-measurements';
import { useDialog } from '../../../../hooks/use-dialog';
import { runMutation } from '../../../../utils/vy-mutation';

type DeleteMeasurementsDialogProps = {
  measurementIds: string[];
};

export const DeleteMeasurementsDialog: React.FC<DeleteMeasurementsDialogProps> = ({ measurementIds }) => {
  const { isDialogOpen, handleOpen, handleClose } = useDialog();
  const deleteMeasurementsMutation = useDeleteMeasurements();

  const handleDialogSubmit = async () => {
    handleClose();

    await runMutation(deleteMeasurementsMutation, measurementIds, {
      pending: 'Deleting...',
      success: 'Deleted',
      error: 'Failed to delete measurements',
    });
  };

  return (
    <>
      <Divider className="mt-0" />

      <MenuItem onClick={handleOpen} disabled={isEmptyArray(measurementIds)}>
        <ListItemIcon>
          <VyIcon
            icon="Delete"
            style={{
              color: '#D32F2F',
              transform: 'scale(0.8)',
            }}
          />
        </ListItemIcon>
        <ListItemText sx={{ color: '#D32F2F' }}>Delete measurements</ListItemText>
      </MenuItem>

      <VyDialog
        open={isDialogOpen}
        onClose={handleClose}
        label="Delete"
        labelDescription="Are you sure you want to delete selected measurements?"
        warningText="This action is final and cannot be reversed"
        cancelButtonText="Cancel"
        ctaText="Delete"
        ctaDisabled={deleteMeasurementsMutation.isLoading}
        onSubmit={handleDialogSubmit}
      />
    </>
  );
};
